<ng-container #formDirective="parent-form" thr-parent-form>
    <div class="row">
        <div class="col-12">
            <h3 class="mat-subheading-1 text-blue font-weight-bold">
                <span class="num"></span>
                {{ 'full-data.perform-public-functions' | translate }}
            </h3>
            <p class="mat-caption font-italic">
                <mat-hint>{{ 'full-data.perform-public-functions-help' | translate }}</mat-hint>
            </p>
            <mat-radio-group
                name="fdthnpYesNo"
                [(ngModel)]="client.publicDuties.isImportant"
                (ngModelChange)="onResize()"
                [required]="true"
                [disabled]="isDisabled"
            >
                <div class="row">
                    <div class="col-6 col-sm-3">
                        <mat-radio-button name="fdthnpNo" class="mb-3 mb-sm-4" color="blue-gray" [value]="false">
                            {{ 'general.no' | translate }}
                        </mat-radio-button>
                    </div>
                    <div class="col-6 col-sm-3">
                        <mat-radio-button name="fdthnpYes" class="mb-3 mb-sm-4" color="blue-gray" [value]="true">
                            {{ 'general.yes' | translate }}
                        </mat-radio-button>
                    </div>
                </div>
            </mat-radio-group>
            <div class="row justify-content-end" *ngIf="client.publicDuties.isImportant">
                <div class="col-12 col-sm-9">
                    <mat-radio-group
                        name="fdthnpWhich"
                        [(ngModel)]="client.publicDuties.importantFreeText"
                        (ngModelChange)="onResize()"
                        [required]="true"
                        [disabled]="isDisabled"
                    >
                        <div class="row">
                            <div class="col-12 col-sm-6 col-lg-4">
                                <mat-radio-button
                                    class="mb-3 mb-sm-4"
                                    name="fdthnpWhichPolitical"
                                    color="blue-gray"
                                    [value]="PublicDutiesOption.POLITICAL"
                                >
                                    {{ 'form.public-duties.political' | translate }}
                                </mat-radio-button>
                            </div>
                            <div class="col-12 col-sm-6 col-lg-4">
                                <mat-radio-button
                                    class="mb-3 mb-sm-4"
                                    name="fdthnpWhichSeniorJudges"
                                    color="blue-gray"
                                    [value]="PublicDutiesOption.SENIOR_JUDGES"
                                >
                                    {{ 'form.public-duties.senior-judges' | translate }}
                                </mat-radio-button>
                            </div>
                            <div class="col-12 col-sm-6 col-lg-4">
                                <mat-radio-button
                                    class="mb-3 mb-sm-4"
                                    name="fdthnpWhichGovernmentInternational"
                                    color="blue-gray"
                                    [value]="PublicDutiesOption.GOVERNMENT_INTERNATIONAL"
                                >
                                    {{ 'form.public-duties.government-international' | translate }}
                                </mat-radio-button>
                            </div>
                            <div class="col-12 col-sm-6 col-lg-4">
                                <mat-radio-button
                                    class="mb-3 mb-sm-4"
                                    name="fdthnpWhichAmbassadors"
                                    color="blue-gray"
                                    [value]="PublicDutiesOption.AMBASSADORS"
                                >
                                    {{ 'form.public-duties.ambassadors' | translate }}
                                </mat-radio-button>
                            </div>
                            <div class="col-12 col-sm-6 col-lg-4">
                                <mat-radio-button
                                    class="mb-3 mb-sm-4"
                                    name="fdthnpWhichOthers"
                                    color="blue-gray"
                                    [value]="PublicDutiesOption.OTHERS"
                                >
                                    {{ 'form.public-duties.others' | translate }}
                                </mat-radio-button>
                            </div>
                        </div>
                    </mat-radio-group>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <h3 class="mat-subheading-1 text-blue font-weight-bold">
                <span class="num"></span>
                {{ 'full-data.family-member-public-functions' | translate }}
            </h3>
            <p class="mat-caption font-italic">
                <mat-hint>{{ 'full-data.family-member-public-functions-help' | translate }}</mat-hint>
            </p>
            <mat-radio-group
                name="fdthnpYesNoRelative"
                [(ngModel)]="client.publicDuties.isImportantRelative"
                (ngModelChange)="onImportantRelativeChange()"
                [required]="true"
                [disabled]="isDisabled"
            >
                <div class="row">
                    <div class="col-6 col-sm-3">
                        <mat-radio-button name="fdthnpNoRelative" class="mb-3 mb-sm-4" color="blue-gray" [value]="false">
                            {{ 'general.no' | translate }}
                        </mat-radio-button>
                    </div>
                    <div class="col-6 col-sm-3">
                        <mat-radio-button name="fdthnpYesRelative" class="mb-3 mb-sm-4" color="blue-gray" [value]="true">
                            {{ 'general.yes' | translate }}
                        </mat-radio-button>
                    </div>
                </div>
            </mat-radio-group>
        </div>
        <div class="col-12">
            <div class="row justify-content-end" *ngIf="client.publicDuties.isImportantRelative">
                <div class="col-12" *ngIf="client.publicDuties.relativeRelationship.length > 0">
                    <table class="table participants mb-3 mb-sm-4">
                        <thead>
                            <tr>
                                <th>{{ 'form.relationship' | translate }}</th>
                                <th>{{ 'form.name' | translate }}</th>
                                <th class="d-none d-md-table-cell">
                                    {{ 'form.surname' | translate }}
                                </th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-template ngFor let-relationship [ngForOf]="client.publicDuties.relativeRelationship">
                                <tr>
                                    <td>
                                        <strong>{{ 'form.relationship-code.' + relationship.code | translate }}</strong>
                                    </td>
                                    <td>
                                        <strong>{{ relationship.name }}</strong>
                                    </td>
                                    <td class="d-none d-md-table-cell">
                                        <strong>{{ relationship.surname }}</strong>
                                    </td>
                                    <td class="text-right">
                                        <button
                                            type="button"
                                            class="mat-elevation-z0"
                                            mat-icon-button
                                            (click)="onEdit(relationship)"
                                            *ngIf="!isDisabled"
                                        >
                                            <i class="icon-edit"></i>
                                        </button>
                                        <button
                                            type="button"
                                            class="mat-elevation-z0"
                                            mat-icon-button
                                            (click)="onRemove(relationship)"
                                            *ngIf="!isDisabled"
                                        >
                                            <i class="icon-delete"></i>
                                        </button>
                                    </td>
                                </tr>
                            </ng-template>
                        </tbody>
                    </table>
                </div>
                <div class="col-12 col-sm-9">
                    <thr-full-data-form-relationship
                        [relationship]="currentRelationship"
                        [isDisabled]="isDisabled"
                        *ngIf="adding || editing"
                    ></thr-full-data-form-relationship>
                </div>
            </div>
        </div>
    </div>

    <div class="row justify-content-between" *ngIf="!isDisabled">
        <ng-container *ngIf="!adding && !editing">
            <div class="col-12 col-sm-6 col-md-4">
                <button
                    type="button"
                    class="full-width mat-elevation-z0"
                    mat-raised-button
                    color="gray"
                    (click)="onAdd()"
                    *ngIf="client.publicDuties.isImportantRelative && !client.publicDuties.isFull()"
                >
                    {{ 'general.add-other' | translate }}
                </button>
            </div>
            <div class="col-12 col-sm-6 col-md-4 mt-3 mt-sm-0" *ngIf="!isDisabledSubmit">
                <button type="submit" class="full-width mat-elevation-z0" mat-raised-button color="blue" [disabled]="!isFormValid">
                    {{ 'general.save' | translate }}
                </button>
            </div>
        </ng-container>
        <ng-container *ngIf="adding || editing">
            <div class="col-12 col-sm-6 col-md-4">
                <button
                    type="button"
                    class="full-width mat-elevation-z0"
                    mat-raised-button
                    color="gray"
                    (click)="onCancel()"
                    *ngIf="client.publicDuties.relativeRelationship.length > 0"
                >
                    {{ 'general.cancel' | translate }}
                </button>
            </div>
            <div class="col-12 col-sm-6 col-md-4 mt-3 mt-sm-0">
                <button
                    type="button"
                    class="full-width mat-elevation-z0"
                    mat-raised-button
                    color="blue"
                    [disabled]="!currentRelationship || !currentRelationship.isComplete()"
                    (click)="onSave()"
                >
                    {{ 'general.add' | translate }}
                </button>
            </div>
        </ng-container>
    </div>
</ng-container>
